import moment from 'moment';
moment.updateLocale('en', {
    week: {
        dow: 1, // Monday is the first day of the week.
    }
});
const distancePeriodsAll = [
    { name: "Today", value: "today" },
    { name: "Yesterday", value: "yesterday" },
    { name: "Last Two Days", value: "last2days" },
    { name: "Last Three Days", value: "last3Days" },
    { name: "This Week", value: "thisweektonow" },
    { name: "This Month", value: "thismonthtonow" },
    { name: "6 Hours", value: "hours6" },
    { name: "12 Hours", value: "hours12" },
    { name: "24 Hours", value: "hours24" },
    { name: "48 Hours", value: "hours48" },
    { name: "Yesterday till Now", value: "yesterdaytonow" },
    { name: "Last 2 Days Till Now", value: "last2daystonow" },
    { name: "Last 3 Days Till Now", value: "last3daystonow" },
];


export const distancePeriodsMain = [
    { name: "Today", value: "today" },
    { name: "Yesterday", value: "yesterday" },
    { name: "Yesterday till Now", value: "yesterdaytonow" },
    { name: "Last Two Days", value: "last2days" },
    { name: "This Week", value: "thisweektonow" },
    { name: "Last Week", value: "lastweek" },
    { name: "This Month", value: "thismonthtonow" },
    { name: "Last Month", value: "lastmonth" },
];

export const distancePeriodsAllwithDates = () => {
    let dispd = {};
    distancePeriodsAll.forEach((d) => {
        let perd = getperiod(d.value);
        const fromDateTime = perd.fromDate.format('YYYY-MM-DD HH:mm:ss');
        const toDateTime = perd.toDate.format('YYYY-MM-DD HH:mm:ss');
        dispd = {
            ...dispd,
            [d.value]: {
                value: d.value,
                fromDateTime,
                toDateTime,
            }
        };
    });
    return dispd;
}

export const distancePeriodsMainwithDates = () => {
    let dispd = {};
    distancePeriodsMain.forEach((d) => {
        let perd = getperiod(d.value);
        const fromDateTime = perd.fromDate.format('YYYY-MM-DD HH:mm:ss');
        const toDateTime = perd.toDate.format('YYYY-MM-DD HH:mm:ss');
        dispd = {
            ...dispd,
            [d.value]: {
                value: d.value,
                fromDateTime,
                toDateTime,
            }
        };
    });
    return dispd;
}

export const getperiod = (periodType) => {

    const _rightNow = moment();
    const _todayStart = moment().startOf('day');
    const _thisWeekStart = moment().startOf('week');
    const _yesterdayStart = moment().subtract(1, 'days').startOf('day');
    const _yesterdayEnd = moment().subtract(1, 'days').endOf('day');
    const _thisMonthStart = moment().startOf('month');
    const _lastTwoDaysStart = moment().subtract(2, 'days').startOf('day');
    const _lastThreeDaysStart = moment().subtract(3, 'days').startOf('day');
    const _6hourStart = moment().subtract(6, 'hours');
    const _12hourStart = moment().subtract(12, 'hours');
    const _24hourStart = moment().subtract(24, 'hours');
    const _48hourStart = moment().subtract(48, 'hours');
    const _lastWeekStart = moment().subtract(1, 'weeks').startOf('week');
    const _lastWeekEnd = moment().subtract(1, 'weeks').endOf('week');
    const _lastMonthStart = moment().subtract(1, 'months').startOf('month');
    const _lastMonthEnd = moment().subtract(1, 'months').endOf('month');

    let fromDate;
    let toDate;
    switch (periodType) {
        case 'today':
            fromDate = _todayStart;
            toDate = _rightNow;
            break;
        case 'yesterday':
            fromDate = _yesterdayStart;
            toDate = _yesterdayEnd;
            break;
        case 'yesterdaytonow':
            fromDate = _yesterdayStart;
            toDate = _rightNow;
            break;
        case 'thisweek':
            fromDate = _thisWeekStart;
            toDate = _yesterdayEnd;
            break;
        case 'thisweektonow':
            fromDate = _thisWeekStart;
            toDate = _rightNow;
            break;
        case 'thismonth':
            fromDate = _thisMonthStart;
            toDate = _yesterdayEnd;
            break;
        case 'thismonthtonow':
            fromDate = _thisMonthStart;
            toDate = _rightNow;
            break;
        case 'last2days':
            fromDate = _lastTwoDaysStart;
            toDate = _yesterdayEnd;
            break;
        case 'last3Days':
            fromDate = _lastThreeDaysStart;
            toDate = _yesterdayEnd;
            break;
        case 'last2daystonow':
            fromDate = _lastTwoDaysStart;
            toDate = _rightNow;
            break;
        case 'last3daystonow':
            fromDate = _lastThreeDaysStart;
            toDate = _rightNow;
            break;
        case 'hours6':
            fromDate = _6hourStart;
            toDate = _rightNow;
            break;
        case 'hours12':
            fromDate = _12hourStart;
            toDate = _rightNow;
            break;
        case 'hours24':
            fromDate = _24hourStart;
            toDate = _rightNow;
            break;
        case 'hours48':
            fromDate = _48hourStart;
            toDate = _rightNow;
            break;
        case 'lastweek':
            fromDate = _lastWeekStart;
            toDate = _lastWeekEnd;
            break;
        case 'lastmonth':
            fromDate = _lastMonthStart;
            toDate = _lastMonthEnd;
            break;
        default:
            break;
    }

    return { "fromDate": fromDate, "toDate": toDate };
}


export const distancePeriodNames = {
    today: "Today",
    yesterday: "Yesterday",
    last2days: "Last Two Days",
    last3Days: "Last Three Days",
    thisweektonow: "This Week",
    thismonthtonow: "This Month",
    hours6: "6 Hours",
    hours12: "12 Hours",
    hours24: "24 Hours",
    hours48: "48 Hours",
    yesterdaytonow: "Yesterday till Now",
    last2daystonow: "Last 2 Days Till Now",
    last3daystonow: "Last 3 Days Till Now",
    lastweek: "Last Week",
    lastmonth: "Last Month",
};

export const distancePeriodValues = {
    "Today": "today",
    "Yesterday": "yesterday",
    "Last Two Days": "last2days",
    "Last Three Days": "last3Days",
    "This Week": "thisweektonow",
    "This Month": "thismonthtonow",
    "6 Hours": "hours6",
    "12 Hours": "hours12",
    "24 Hours": "hours24",
    "48 Hours": "hours48",
    "Yesterday till Now": "yesterdaytonow",
    "Last 2 Days Till Now": "last2daystonow",
    "Last 3 Days Till Now": "last3daystonow",
};

export const kmReportPeriods = [
    "today",
    "yesterday",
    "yesterdaytonow",
    "last2days",
    "thisweektonow",
    "thismonthtonow"
];

export const periodOptions = [
    { name: "Today", value: "today" },
    { name: "Yesterday", value: "yesterday" },
    { name: "Yesterday till Now", value: "yesterdaytonow" },
    { name: "Last Two Days", value: "last2days" },
    { name: "Last Three Days", value: "last3Days" },
    { name: "This Week", value: "thisweektonow" },
    { name: "This Month", value: "thismonthtonow" },
];

export const periodOptionsBrief = [
    { name: "Today", value: "today" },
    { name: "Yesterday", value: "yesterday" },
    { name: "Yesterday till Now", value: "yesterdaytonow" },
    { name: "Last Two Days", value: "last2days" },
    { name: "Last Three Days", value: "last3Days" },
];

export const periodOptionsInline = [
    { name: "Today", value: "today" },
    { name: "Yesterday", value: "yesterday" },
    { name: "This Week", value: "thisweektonow" },
    { name: "This Month", value: "thismonthtonow" },
];

export const minStopOptions = [
    { name: '1 Minute', value: 1 },
    { name: '2 Minute', value: 2 },
    { name: '5 Minute', value: 5 },
    { name: '10 Minute', value: 10 },
    { name: '20 Minute', value: 20 },
    { name: '30 Minute', value: 30 },
    { name: '1 Hour', value: 60 },
    { name: '2 Hours', value: 120 },
    { name: '5 Hours', value: 300 },

];
 /**
*
*/